import * as ActionTypes from '../components/actions/types';

const initialState = {
  profileList: [],
  rejectedList: []
};

function cmsEventScreeningReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.FETCH_CMS_EVENT_SCREENING:
      return action.payload;

    default:
      return state;
  }
}

export default cmsEventScreeningReducer;



// WEBPACK FOOTER //
// ./src/reducers/cmsEventScreening.js